/* Nische offer ladder — inline expanding panel with copyable discount codes.
   Rung 1 is a shipping rate condition (no code). Rungs 2-3 are Shopify discount codes.

   Two contexts, one markup (see the snippet):
     product — state is refreshed from /cart.js when the panel opens.
     cart    — lives inside the cart drawer, which Dawn re-renders on every
               cart change with the state already baked in server-side, so it
               never fetches. A re-render replaces the DOM, so we watch for new
               instances and re-open the panel if the shopper had it open. */
(function () {
  if (window.NischeOfferLadder) return;
  window.NischeOfferLadder = true;

  var CURRENCY = '₹';
  function money(rupees) {
    return CURRENCY + Math.round(rupees).toLocaleString('en-IN');
  }

  function copyText(text, btn) {
    var span = btn.querySelector('[data-nol-copytext]');
    var original = btn.dataset.nolOriginal || (span ? span.textContent : '');
    btn.dataset.nolOriginal = original;

    var done = function () {
      if (span) span.textContent = 'Copied';
      btn.classList.add('is-copied');
      clearTimeout(btn._nolTimer);
      btn._nolTimer = setTimeout(function () {
        if (span) span.textContent = original;
        btn.classList.remove('is-copied');
      }, 1800);
    };

    var fallback = function () {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:absolute;left:-9999px;top:0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); done(); } catch (e) { /* nothing to do */ }
      document.body.removeChild(ta);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(fallback);
    } else {
      fallback();
    }
  }

  function init(root) {
    if (root.dataset.nolReady === 'true') return;
    root.dataset.nolReady = 'true';

    if (root.dataset.nolCurrency) CURRENCY = root.dataset.nolCurrency.replace(/\s+$/, '') + ' ';
    if (CURRENCY === '₹ ') CURRENCY = '₹';

    var trigger = root.querySelector('[data-nol-toggle]');
    var panel = root.querySelector('[data-nol-panel]');
    if (!trigger || !panel) return;

    var rungs = Array.prototype.slice.call(panel.querySelectorAll('.nol-rung'));
    var progress = panel.querySelector('[data-nol-progress]');

    function paint(subtotal) {
      var next = null;
      var best = null;

      rungs.forEach(function (li) {
        var spend = parseFloat(li.dataset.spend || '0');
        var unlocked = subtotal >= spend;
        li.classList.toggle('is-unlocked', unlocked);
        li.classList.remove('is-best');
        if (unlocked && li.dataset.code) best = li;
        if (!unlocked && !next) next = li;

        var state = li.querySelector('[data-nol-state]');
        if (!state) return;
        if (unlocked) {
          state.textContent = 'Unlocked';
        } else {
          // A locked rung hides its code (see the CSS), so the gap has to say
          // what earns it. Free shipping has no code, so it just states the gap.
          var gap = 'Add ' + money(spend - Math.max(subtotal, 0)) + ' more';
          state.textContent = li.dataset.code ? gap + ' to unlock coupon' : gap;
        }
      });

      // The highest unlocked code rung keeps its outline, but every unlocked
      // rung just reads "Unlocked" — no separate label.
      if (best) best.classList.add('is-best');

      if (!progress) return;
      if (subtotal <= 0) {
        progress.textContent = 'Add something to your cart to start unlocking these.';
      } else if (next) {
        var win = next.dataset.kind === 'ship'
          ? 'free shipping'
          : money(parseFloat(next.dataset.amount)) + ' off with ' + next.dataset.code;
        progress.textContent = 'Add ' + money(parseFloat(next.dataset.spend) - subtotal) +
          ' more to your cart to get ' + win + '.';
      } else if (best) {
        progress.textContent = 'Use ' + best.dataset.code + ' at checkout for ' +
          money(parseFloat(best.dataset.amount)) + ' off.';
      } else {
        progress.textContent = "You've unlocked every offer on this order.";
      }
      progress.hidden = false;
    }

    function refresh() {
      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root_url + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          var paise = cart.items_subtotal_price;
          if (typeof paise !== 'number') paise = cart.original_total_price || 0;
          paint(paise / 100);
        })
        .catch(function () { /* leave the static ladder as rendered */ });
    }

    var inCart = root.dataset.nolContext === 'cart';
    var OPEN_KEY = 'nol-cart-open';

    function setOpen(open) {
      trigger.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
      if (inCart) {
        try { open ? sessionStorage.setItem(OPEN_KEY, '1') : sessionStorage.removeItem(OPEN_KEY); } catch (e) { /* private mode */ }
      }
    }

    trigger.addEventListener('click', function () {
      var open = trigger.getAttribute('aria-expanded') === 'true';
      setOpen(!open);
      // The drawer's own re-render keeps the cart copy right; only the product page needs to ask.
      if (!open && !inCart) refresh();
    });

    // The drawer re-renders on every cart change and hands us a fresh, closed
    // panel. If the shopper had it open, keep it open.
    if (inCart) {
      var wasOpen = false;
      try { wasOpen = sessionStorage.getItem(OPEN_KEY) === '1'; } catch (e) { /* ignore */ }
      if (wasOpen) setOpen(true);
    }

    panel.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-nol-copy]');
      if (btn) copyText(btn.dataset.nolCopy, btn);
    });

    startClock(root, panel);
  }

  function startClock(root, panel) {
    if (root.dataset.nolCountdown !== 'true') return;
    var end = root.dataset.nolEnd;
    if (!end) return;
    var target = new Date(end + 'T23:59:59+05:30').getTime();
    if (isNaN(target)) return;

    var box = panel.querySelector('[data-nol-clock]');
    var note = panel.querySelector('[data-nol-clocknote]');
    if (!box) return;

    var cells = [];
    ['DAYS', 'HRS', 'MINS', 'SECS'].forEach(function (name) {
      var unit = document.createElement('span');
      unit.className = 'nol-clock__unit';
      var value = document.createElement('b');
      var label = document.createElement('i');
      label.textContent = name;
      unit.appendChild(value);
      unit.appendChild(label);
      box.appendChild(unit);
      cells.push(value);
    });

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      if (!root.isConnected) { clearInterval(root._nolClock); return; }
      var left = target - Date.now();
      if (left <= 0) {
        root.hidden = true; // campaign is over — say nothing rather than promise
        return;
      }
      var secs = Math.floor(left / 1000);
      cells[0].textContent = pad(Math.floor(secs / 86400));
      cells[1].textContent = pad(Math.floor((secs % 86400) / 3600));
      cells[2].textContent = pad(Math.floor((secs % 3600) / 60));
      cells[3].textContent = pad(secs % 60);
      box.hidden = false;
      if (note) {
        note.textContent = 'Offers end ' + new Date(target).toLocaleDateString('en-IN', { day: 'numeric', month: 'long' });
        note.hidden = false;
      }
    }

    tick();
    root._nolClock = setInterval(tick, 1000); // one second, so it actually moves
  }

  function boot() { document.querySelectorAll('[data-nol]').forEach(init); }

  // Dawn replaces the drawer's inner HTML from the Section Rendering API after
  // every add / remove / quantity change. init() is idempotent, so we just
  // re-run boot when nodes land. Coalesced to one pass per frame.
  function watchForRerenders() {
    if (!window.MutationObserver) return;
    var queued = false;
    new MutationObserver(function (records) {
      if (queued) return;
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) { queued = true; break; }
      }
      if (!queued) return;
      requestAnimationFrame(function () { queued = false; boot(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); watchForRerenders(); });
  } else {
    boot();
    watchForRerenders();
  }
})();
